import React from 'react';
import PipelinesTable from './PipelinesTable';

const CustomerPipelines = () => {
    return <PipelinesTable stage={"customer"}/>
}

export default CustomerPipelines;